// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3KXmz","text":"SelectPayment_text__2PU6L","title":"SelectPayment_title__2ULU9","btn":"SelectPayment_btn__-EPd0"};